import {
  Col, Row, Space,
} from 'antd';
import { Text } from './Text';
import { formatCurrency } from '../utils/shared';
import CouponDTO from '../types/Coupon';

interface TicketInfoProps {
  color: string
  title: string
  description: string
  price: number
  coupon?: CouponDTO;
}

const TicketInfo = ({
  color, title, description, price, coupon,
}: TicketInfoProps) => (
  <Row justify='space-between'>
    <Col className='flex gap-2 ml-5'>
      <div className='rounded-full h-5 w-5' style={{ backgroundColor: color }}></div>
      <Space direction='vertical' size={0}>
        <Text size='sm' medium color='text-text-primary'>{title}</Text>
        <Text size='xs' color='text-text-secondary'>{description}</Text>
      </Space>
    </Col>
    <Col span={8} className='text-right mr-5'>
      {coupon && <Text size='xs' color='text-text-secondary line-through mr-2'>{formatCurrency(price)}</Text>}
      <Text size='md' color='text-text-primary'>{formatCurrency(coupon ? price - (price * (coupon.value)) : price)}</Text>
    </Col>
  </Row>
);

export default TicketInfo;
